import React from "react";
import HrSidebar from "../components/Sidebar/HrSidebar";
import HrHeader from "../components/Header/HrHeader";

export default function HrLayout({ children }) {
  return (
    <div className="flex h-screen bg-gray-100">
      <HrSidebar />
      <div className="flex-1 flex flex-col">
        <HrHeader />
        <main className="flex-1 overflow-auto">{children}</main>
      </div>
    </div>
  );
}
